import { render } from "./comment.vue?vue&type=template&id=5009684e"
const script = {}
script.render = render

export default script